import { FEEDBACK_CATEGORIES, FEEDBACK_NOTE_MAX, FEEDBACK_NOTICE, createFeedbackDraft, type FeedbackCategory } from "../core/feedback.ts";
import { el } from "./dom.ts";

/**
 * Màn chọn lý do 👎 (Story 5.6 apus-ami-agent, FR-120) — tách khỏi View để test bằng DOM thật (View nạp CSS nên `node --test` không
 * nạp được). Tự xử lý click của chính nó; trạng thái nằm ở FeedbackDraft (thuần). View chỉ chèn nó vào dưới câu trả lời và đóng nó
 * khi gửi xong (`settleFeedbackForm`).
 *   • chọn đúng MỘT mã trong bốn mã; nút Gửi chỉ mở khi đã chọn;
 *   • Gửi ⇒ `onSubmit({category, note?})` (ghi chú tỉa, rỗng thì bỏ, cắt ở 400) và khoá nút Gửi tới khi `settleFeedbackForm`;
 *   • Huỷ ⇒ gỡ màn, KHÔNG gọi onSubmit;
 *   • thông báo O-10: câu hỏi + trích đoạn có thể được quản trị viên xem.
 */
export interface FeedbackFormOptions {
  onSubmit(payload: { category: FeedbackCategory; note?: string }): void;
  onCancel?(): void;
}

export function createFeedbackForm(opts: FeedbackFormOptions): HTMLElement {
  const draft = createFeedbackDraft();
  const form = el("div", "apx-fb", { role: "group", "aria-label": "Vì sao câu trả lời chưa tốt?" });
  const title = el("div", "apx-fb-title");
  title.textContent = "Vì sao câu trả lời chưa tốt?";
  const cats = el("div", "apx-fb-cats", { role: "radiogroup", "aria-label": "Lý do" });
  for (const [code, label] of FEEDBACK_CATEGORIES) {
    const b = el("button", "apx-fb-cat", { type: "button", role: "radio", "aria-checked": "false", "data-fb-cat": code });
    b.textContent = label;
    cats.appendChild(b);
  }
  const note = el("textarea", "apx-fb-note", { rows: "2", maxlength: String(FEEDBACK_NOTE_MAX), placeholder: "Ghi chú thêm (không bắt buộc)", "aria-label": "Ghi chú thêm" });
  const notice = el("p", "apx-fb-notice");
  notice.textContent = FEEDBACK_NOTICE;
  const row = el("div", "apx-fb-row");
  const cancel = el("button", "apx-fb-btn", { type: "button", "data-fb-do": "cancel" });
  cancel.textContent = "Huỷ";
  const send = el("button", "apx-fb-btn apx-fb-send", { type: "button", "data-fb-do": "send", "data-fb-send": "" });
  send.textContent = "Gửi phản hồi";
  send.disabled = true;
  row.append(cancel, send);
  form.append(title, cats, note, notice, row);

  form.addEventListener("click", (event) => {
    const target = event.target as HTMLElement | null;
    if (!target?.closest) return;
    const pick = target.closest("[data-fb-cat]") as HTMLElement | null;
    if (pick) {
      draft.select(pick.getAttribute("data-fb-cat"));
      form.querySelectorAll("[data-fb-cat]").forEach((b) => b.setAttribute("aria-checked", String(b.getAttribute("data-fb-cat") === draft.category)));
      send.disabled = !draft.canSend();
      return;
    }
    const act = target.closest("[data-fb-do]") as HTMLElement | null;
    if (!act) return;
    if (act.getAttribute("data-fb-do") === "cancel") {
      form.remove();
      opts.onCancel?.();
      return;
    }
    const payload = draft.payload(note.value);
    if (!payload || send.disabled) return;
    send.disabled = true;
    opts.onSubmit(payload);
  });
  return form;
}

/** Gửi xong thì đóng màn chọn lý do; lỗi thì mở lại nút Gửi để thử lại (lựa chọn và ghi chú còn nguyên). */
export function settleFeedbackForm(form: Element | null | undefined, ok: boolean): void {
  if (!form) return;
  if (ok) {
    form.remove();
    return;
  }
  const send = form.querySelector("[data-fb-send]") as HTMLButtonElement | null;
  if (send) send.disabled = false;
}
